<template>
  <div class="lc-users">
    <popup :title="$t('view.livechat.clearModerator.popup.title')" ref="popupEditGuard">
      <div class="popup-subtext">{{ $t('view.livechat.clearModerator.popup.subtitle') }}</div>
      <template v-slot:buttons>
        <btn icon="trash" color="red" @click="clearModeratorRequests()">{{ $t('view.livechat.clearModerator.popup.yes') }}</btn>
        <btn icon="undo" @click="closeModeratorRequestsPopup()">{{ $t('btn.cancel') }}</btn>
      </template>
    </popup>
    <div class="lc-users__content" ref="refMain">
      <div class="lc-users__search-bar" ref="refSBar">
        <in
          class="lc-users__search-input"
          v-model="searchText"
          :placeholder="$t('view.livechat.searchBar')"
          @keyup.enter="setFinalSearchText()"
        />
        <div class="lc-users__tags-cont">
          <div
            :class="['lc-users__tag', item.filter ? 'lc-users__tag--selected' : '']"
            v-for="(item, index) in tags"
            :key="index"
            @click="tagClick(index)"
          >
            <dynamic-text
              :ref="'dText'+index"
              :class="['lc-users__tag-text', !item.editable ? 'lc-users__tag-text--muted' : '']"
              :minWidth="40"
              :maxlength="20"
              :value="item.name"
              @blur="onTagEditBlur(index)"
              @changed="editTag(index, $event)"
            />
            <fai class="lc-users__tag-del" icon="times" @click.stop="deleteTag(index)" v-show="!item.filter"></fai>
          </div>
          <div class="lc-users__tag">
            <dynamic-text
              class="lc-users__tag-text"
              :value="newTag"
              :minWidth="40"
              :maxlength="20"
              :placeholder="'tag'"
              @changed="addNewTag($event)"
            />
          </div>
        </div>
        <div class="lc-users__clear-mod-btn"
          @click="showClearModeratorRequestsPopup">
          <div class="lc-users__clear-mod-btn-text">{{ $t('view.livechat.clearModerator.btn') }}</div>
        </div>
      </div>
      <div class="lc-users__users-list" ref="refUserList">
        <div
          class="lc-users__header"
          v-for="(item, index) in usersGroups"
          :key="index+'0'"
          :style="{ 'order': index*3 }"
          @click="item.toggled = !item.toggled"
        >
          <div class="lc-users__header-gradient"/>
          <div class="lc-users__header-content">
            <div class="lc-users__header-text">{{ item.name }}</div>
            <fai
              icon="chevron-down"
              :class="['lc-users__header-icon', !item.toggled ? 'lc-users__header-icon--rotated' : '']"
            />
          </div>
        </div>
        <div
          class="lc-users__navi"
          v-for="(item, index) in usersGroups"
          :key="index+'0000'"
          :style="{ 'order': index*3+2 }"
          v-show="item.toggled"
        >
          <div class="lc-users__navi-cont">
            <div class="lc-users__navi-arrows lc-users__navi-left">
              <fai icon="caret-left" @click="downPagingIter(item)"/>
            </div>
            <div class="lc-users__navi-text">
              <in class="lc-users__navi-input" :value="formatInputValue(item)"/>
            </div>
            <div class="lc-users__navi-arrows lc-users__navi-right">
              <fai icon="caret-right" @click="upPagingIter(item)"/>
            </div>
          </div>
        </div>
        <livechat-user-group
          v-for="(item, index) in usersGroups"
          :key="index+'1'"
          :style="{ 'order': index*3+1 }"
          :class="['lc-users__users-group',
          !item.toggled ? 'lc-users__users-group--hidden' : '']"
          :users="(filterUsersByTags(filterUsersByName(users)).filter(x => item.filter(x))).sort(item.comp)"
          :userGroup="item"
          :tags="actTags"
          :selectedUser="selectedUser"
          :socket="socket"
          @selected="selectUser"
        >
          <!-- <template v-slot:after>
            <div class="lc-users__users-group-last-elem">
              <div class="lc-users__next-cont" @click="getNextUsers(item)">
                <full-spinner
                  v-if="item.loading"
                  class="lc-users__loader-spinner lc-users__next-shape"
                  :signalDone="item.receivedAction"
                  @done="item.loading = false"
                />
                <div class="lc-users__next lc-users__next-shape">
                  <fai class="lc-users__next-icon" v-if="!item.loading" icon="chevron-down"/>
                </div>
              </div>
            </div>
          </template>-->
        </livechat-user-group>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      actUsers: [],
      actTags: [],
      newTag: '',
      clickMem: false,
      searchText: '',
      searchTextFinal: ''
    }
  },

  props: {
    users: Array,
    tags: Array,
    selectedUser: Object,
    usersGroups: Array,
    socket: null
  },

  watch: {
    users: function () {
      this.actUsers = this.users
    },

    tags: function () {
      this.actTags = this.tags
      this.rescaleList()
    }
  },

  mounted() {
    if (this.users) this.actUsers = this.users
    if (this.tags) this.actTags = this.tags
    this.rescaleList()
  },

  methods: {
    formatInputValue(group) {
      return group.pagingIter + 1 + '/' + (Math.floor(group.count / group.pageLimit) + 1)
    },

    upPagingIter(group) {
      if ((group.pagingIter + 1) * group.pageLimit < group.count) group.pagingIter++
    },

    downPagingIter(group) {
      if (group.pagingIter > 0) group.pagingIter--
    },

    setFinalSearchText() {
      this.searchTextFinal = this.searchText
    },

    rescaleList() {
      const searchElem = this.$refs.refSBar
      const listElem = this.$refs.refUserList
      const mainElem = this.$refs.refMain

      setTimeout(() => {
        listElem.style.height = mainElem.clientHeight - searchElem.clientHeight - 50 + 'px'
        this.rescaleList()
      }, 100)
    },

    filterUsersByName(users) {
      if (this.searchTextFinal === '') return users
      return users.filter((item) => {
        const fullName = item.userData.first_name + ' ' + item.userData.last_name
        if (fullName.toLowerCase().includes(this.searchTextFinal.toLowerCase())) return true
        return false
      })
    },

    filterUsersByTags(users) {
      let filtered = users
      for (let i = 0; i < this.tags.length; i++) {
        const actTag = this.tags[i]
        if (!actTag.filter) continue
        filtered = filtered.filter((item) => {
          for (let j = 0; j < item.liveData.tags.length; j++) {
            if (item.liveData.tags[j] == actTag) return true
          }
          return false
        })
      }
      return filtered
    },

    tagClick(index) {
      if (this.actTags[index].editable) return
      if (!this.clickMem) {
        this.clickMem = true
        setTimeout(() => {
          if (this.clickMem) { // dbl click not occured
            this.clickMem = false
            this.toggleTag(index)
          }
        }, 300)
      } else {
        this.clickMem = false
        this.enableEditTag(index)
      }
    },

    toggleTag(index) {
      this.actTags[index].filter = !this.actTags[index].filter
      //this.filteredUsers = this.filterUsersByTags(this.users)
    },

    enableEditTag(index) {
      this.actTags[index].editable = true

      setTimeout(() => {
        const elem = this.$refs['dText' + index][0].$el.children[0]
        elem.focus()
      }, 0)
    },

    onTagEditBlur(index) {
      this.actTags[index].editable = false
    },

    async editTag(index, value) {
      try {
        const actTag = this.actTags[index]
        this.$refs['dText' + index][0].$el.children[0].blur()
        actTag.editable = false
        if (!value.length || value.length > 20) {
          return
        }

        const res = await axios.put('/api/livechat/tags', {
          tag: {
            id: actTag.id,
            name: value
          }
        })

        actTag.name = value
      } catch (e) {
        console.error(e)
      }
    },

    async addNewTag(newTag) {
      try {
        if (!newTag.length) return

        this.newTag = newTag
        const res = await axios.post('/api/livechat/tags', {
          tags: [{
            name: newTag
          }]
        })

        this.actTags.push({
          name: newTag,
          id: res.data.keys[0],
          filter: false,
          editable: false,
          users: []
        })

        this.newTag = ''
      } catch (e) {
        console.error(e)
      }
    },

    async deleteTag(index) {
      try {
        const actTag = this.actTags[index]
        const res = await axios.delete('/api/livechat/tags', { data: {
          tags: [actTag.id]
        }})

        for (let i = 0; i < actTag.users.length; i++) {
          const actUser = actTag.users[i]
          for (let j = 0; j < actUser.liveData.tags.length; j++) {
            if (actTag.id === actUser.liveData.tags[j].id) {
              actUser.liveData.tags.splice(j, 1)
            }
          }
        }

        this.actTags.splice(index, 1)
      } catch (e) {
        console.error(e)
      }
    },

    showClearModeratorRequestsPopup() {
      this.$refs.popupEditGuard.open()
    },

    closeModeratorRequestsPopup() {
      this.$refs.popupEditGuard.close()
    },

    async clearModeratorRequests() {
      try {
        await axios.delete('/api/livechat/awaiting-users')

        for(let i = 0; i<this.actUsers.length; i++) {
          const user = this.actUsers[i]
          user.userData.moderator_chat = false
          user.userData.moderator_chat_order = null
        }

        this.$refs.popupEditGuard.close()
      } catch (e) {
        console.error(e)
      }
    },

    getUserNameForCard(userData) {
      return userData.first_name + ' ' + userData.last_name
    },

    selectUser(user) {
      this.$emit('selected', user)
    },

    getNextUsers(userGroup) {
      userGroup.receivedAction = false
      this.socket.emit('getNextUsers', userGroup.offset, userGroup.dbParam)
      userGroup.loading = true
    }
  }
}
</script>

<style lang="scss">
.lc-users {
  background: $bgLightGrey;
  border-radius: 4px;

  &__content {
    height: calc(100% - 10px);
    padding: 10px;
    overflow: hidden;
  }

  &__search-input {
    width: 100%;
  }

  &__users-list {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: calc(100%);
  }

  &__users-group {
    overflow-y: auto;
    margin-bottom: 8px;
    flex: 1;

    &--hidden {
      flex: 0;
    }

    &--last {
      margin-bottom: 0px;
    }
  }

  &__search-bar {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__tags-cont {
    display: flex;
    overflow: hidden;
    margin: -2px;
    flex-wrap: wrap;
  }

  &__tag {
    display: flex;
    margin: 2px;
    padding: 3px 0;
    border: solid 2px $primary;
    background: white;
    border-radius: 1.3em;
    align-items: center;
    cursor: pointer;
  }

  &__tag--selected {
    background: $primary;

    & .lc-users__tag-text {
      color: white;
    }
  }

  &__tag-del {
    margin-right: 6px;
    color: $inactiveGrey;
  }

  &__tag-text {
    font-size: 0.8em;
  }

  &__tag-text--muted {
    pointer-events: none;
  }

  &__clear-mod-btn {
    background: $danger;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    border-radius: 6px;
    color: white;
    font-size: 0.9em;
    cursor: pointer;

    &:hover {
      background: $dangerHover;
    }
  }

  &__clear-mod-btn-text {
    user-select: none;
  }

  &__header {
    cursor: pointer;
    @include boxShadow(-2px, 2px, 10px, -10px, rgba(0, 0, 0, 0.75));
    margin-bottom: 8px;

    display: flex;
  }

  &__header-gradient {
    width: 4px;
    background-color: $primary;
    border-radius: 4px 0px 0px 4px;
  }

  &__header-content {
    flex-grow: 1;
    background: white;
    padding: 6px;
    border-radius: 0px 4px 4px 0px;
    color: black;
    display: flex;
    justify-content: space-between;
    font-size: 0.9em;
    margin: 0px 2px;
  }

  &__header-icon{
    color: $inactiveGrey;
  }

  &__navi {
    margin-bottom: 8px;
  }

  &__navi-cont {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__navi-text {
    display: flex;
    align-items: center;
    margin: 0px 5px;
  }

  &__navi-input {
    user-select: none;
    width: 50px;
    font-size: 0.9em;
    text-align: center;
    pointer-events: none;
    margin-top: -2px;

    & .input {
      text-align: center !important;
    }
  }

  &__navi-arrows {
    font-size: 1.8em;
    cursor: pointer;
    color: $inactiveGrey;
  }

  &__header-icon {
    margin-right: 4px;
    margin-top: 1px;
    transition: transform 0.5s;
    &--rotated {
      transform: rotateX(180deg);
    }
  }

  &__users-group-last-elem {
    display: flex;
    justify-content: center;
  }

  &__next-cont {
    position: relative;
    @include boxShadow(-2px, 2px, 10px, -10px, rgba(0, 0, 0, 0.9));
  }

  &__next-shape {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  &__loader-spinner {
    & > .full-spinner__spinner {
      font-size: 1.25em;
    }
  }

  &__next {
    font-size: 1.1em;
    background-color: $primary;
    color: white;
    cursor: pointer;

    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__next-text {
    margin-right: 6px;
  }

  &__next-icon {
    margin-top: 2px;
    font-size: 1.1em;
  }
}
</style>
